import * as Yup from 'yup'

import { DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT } from '../DocFlowAddRecipientFields'

export function getValidationSchemaDocFlowRecipientModalMultiField() {
  return Yup.object({
    [DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT]: Yup.array()
      .of(Yup.object())
      .min(1, true),
  })
}

export function getValidationSchemaDocFlowRecipientModalSingleField() {
  return Yup.object({
    [DOC_FLOW_ADD_RECIPIENT_FIELDS_FORM_FIELD_RECIPIENT]: Yup.object().required(
      () => true
    ),
  })
}
